/* eslint-disable no-useless-escape */
import { appSchema } from '../../schema/appSchema.js';
import { getDeep } from '../../utils/getDeep.js';

export const replaceArgumentValue =
  (responses) =>
  (stepId, key, opts = {}, map) => {
    const response = responses?.[stepId];
    const systemToHuman = opts?.systemToHuman;
    if (stepId === 'system') {
      const attributes = appSchema?.general?.systemAttributes;
      const keyDef = attributes?.find((a) => a?.value === key);
      const category = keyDef?.category;
      if (!keyDef || !category) {
        return '';
      }
      if (systemToHuman) {
        return keyDef.label;
      }
      return responses?.variables?.system?.[category]?.[key];
    }
    if (stepId === 'memory') {
      return getDeep(key, responses?.variables?.memory);
    }
    if (['functionInputs', 'workflowArguments', 'integrationMetadata']?.includes(stepId)) {
      const cleanedKey = key.replace(/input\[\d+\]\./, '');
      if (stepId === 'integrationMetadata') {
        return responses?.integrationMetadata?.[cleanedKey];
      }
      return response?.[cleanedKey];
    }

    const allowFailureData = opts?.allowFailureData === true || response?.meta?.flowControl?.allowFailureData === true;
    if (response?.success !== true && !allowFailureData) {
      return '';
    }

    // The key could either begin with response[i] or input[i], so we need to get it
    let initialKey = key.split('.')?.[0];

    if (initialKey.endsWith(']')) {
      initialKey = initialKey.split('[')?.[0];
    }

    const data = { [initialKey]: response?.data };

    // Comment this check below to enable non-array outputs
    if (!Array.isArray(data?.[initialKey])) {
      return '';
    }
    if (key.endsWith('[]')) {
      key = key.slice(0, -2);
    }
    if (map && opts.arrayMapKey) {
      if (opts.arrayMapKey.endsWith('[]')) {
        opts.arrayMapKey = opts.arrayMapKey.slice(0, -2);
      }

      // We refactored getArrayMapKeys to also return data for each arrayMap, that way we don't need to traverse the data object, which is prone to errors. We just need to find the right data for our arrayMapKey.

      const arrayMapKeyParts = opts.arrayMapKey.split('.');
      let selectedArrayMapData;

      for (let i = arrayMapKeyParts.length - 1; i >= 0; i--) {
        const sliced = arrayMapKeyParts.slice(0, i);
        const joined = sliced.join('.');
        selectedArrayMapData = opts.arrayMapData[joined];
        if (selectedArrayMapData) {
          break;
        }
      }

      // If we reach here and we still don't have data, we return an empty string. I know we could have better error handling, wip.

      if (!selectedArrayMapData) {
        return '';
      }

      // Now we need to find out what key we need to access. For this we have "key", which is the attribute key passed down from the frontend, and we have selectedArrayMapData, which is the data for the arrayMapKey we're looking for. Assuming that every time we have an instance of "[]." in the key is an arrayMap, we can split using that.

      const splitByArrayMap = key.split('[].');
      const keyToAccess = splitByArrayMap[splitByArrayMap.length - 1];

      // We can now use getDeep to access the key we want from the selectedArrayMapData.

      const results = getDeep(keyToAccess, selectedArrayMapData);

      return results;
    }
    const results = getDeep(key, data);
    return results;
  };
